import {
  ComponentInternalInstance,
  getCurrentInstance,
  onUnmounted,
  ref,
  ComputedRef,
  Ref,
  computed,
  watch,
} from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
import { drawerHandler } from '@/renderer/scripts/composition/drawerHandler';
import store from '@/renderer/store';
import { DrawerEvents } from '@/renderer/store/modules/drawer';
import ipc from '@/renderer/scripts/utils/ipc';
import { SMH } from '@/renderer/scripts/smh';
import { isAdminOrSuperAdmin } from '@/renderer/scripts/utils/UserRole/getters';
export const teamSpaceDrawerHandler = (
  defaultParams: ComputedRef<Drawer.TeamSpaceDynamicParams>,
  spaceId: Ref<string> = ref(''),
) => {
  // 当前组件
  const currComponent: ComponentInternalInstance = getCurrentInstance() as ComponentInternalInstance;
  const vm = currComponent.proxy;
  const route = vm.$route;
  // 抽屉相关的代码块
  const { drawerHandlerMethods } = drawerHandler();
  // 初始化的时候，立刻初始化详情组件
  const emptyScope: Drawer.EmptyScope = {
    title: '',
    componentName: 'EmptyDetail',
    params: {
      totalMsg: i18n_t('共有0个文件'),
      title: i18n_t('查看详情信息'),
      desc: i18n_t('选中文件/文件夹查看更详细信息'),
      imgClass: '',
    },
  };
  const showMemberTab = computed(() => {
    // 如果禁止了搜索成员，则需要隐藏根目录的成员 tab
    // 管理员不受到任何限制
    const canSearchMember = store.getters.enableViewAllOrgUser;
    const isNotRoot = defaultParams.value.teamPath.includes('/');
    return isAdminOrSuperAdmin.value || canSearchMember || isNotRoot;
  });
  const setDefaultDrawer = (defaultParams: ComputedRef<Drawer.TeamSpaceDynamicParams>) => {
    const dynamicScope: Drawer.TeamSpaceDynamicScope = {
      title: i18n_t('动态'),
      componentName: 'Dynamic',
      // 个人版本的spaceId 传递为空字符
      params: defaultParams.value,
    };
    const authScope: Drawer.AuthScope<SMH.SpaceFileItemData> = {
      title: i18n_t('成员管理'),
      componentName: 'TeamMemberMange',
    };
    // 只有在teamSpace 空间下才展示成员管理
    if (route.name === 'teamSpace' && showMemberTab.value) {
      return drawerHandlerMethods.setDrawers([dynamicScope, authScope]);
    }
    drawerHandlerMethods.setDrawers([dynamicScope]);
  };
  // 当数据全部加载完毕
  const setTotal = (total: number) => {
    store.commit(DrawerEvents.SET_TOTAL, total);
  };
  ipc.on(ipc.RENDERER_EVENTS_MAP.ON_DATA_LOADED, setTotal);

  // 数据改变时的代码块
  const selectedChange = (selectedList: SMH.SpaceFileItemData[]) => {
    if (selectedList.length === 0) {
      // if (oldList.length === 0) return; // 若第一次发生改变，则return；
      // drawerHandlerMethods.setDrawers([emptyScope]);
      setDefaultDrawer(defaultParams);
    }
    if (selectedList.length === 1) {
      // 初始化的时候，立刻初始化详情组件
      const detailScope: Drawer.DetailScope<SMH.SpaceFileItemData> = {
        title: i18n_t('详细信息'),
        componentName: 'Detail',
        // 个人空间的spaceId会自动传递
        params: {
          selectedItem: selectedList[0],
          spaceId: spaceId.value,
        },
      };
      const dynamicScope: Drawer.DynamicScope<SMH.SpaceFileItemData> = {
        title: i18n_t('动态'),
        componentName: 'Dynamic',
        // 个人版本的spaceId 传递为空字符
        params: {
          selectedItem: selectedList[0],
          spaceId: spaceId.value,
        },
      };
      const historyScope: Drawer.HistoryScope<SMH.SpaceFileItemData> = {
        title: i18n_t('历史版本'),
        componentName: 'History',
        // 个人版本的spaceId 传递为空字符
        params: {
          selectedItem: selectedList[0],
          spaceId: spaceId.value,
        },
      };
      const authScope: Drawer.AuthScope<SMH.SpaceFileItemData> = {
        title: i18n_t('共享管理'),
        componentName: 'FileMemberManage',
        // 个人版本的spaceId 传递为空字符
        params: {
          selectedItem: selectedList[0],
          spaceId: spaceId.value,
        },
      };
      // 团队空间
      let tabs = [];
      if (selectedList[0].type === 'dir') {
        // 当选择的文件/文件夹是共享文件才展示共享管理
        tabs = selectedList[0].isAuthorized ? [detailScope, dynamicScope, authScope] : [detailScope, dynamicScope];
      } else {
        tabs = selectedList[0].isAuthorized ? [detailScope, historyScope, authScope] : [detailScope, historyScope];
      }
      drawerHandlerMethods.setDrawers(tabs);
    }
    if (selectedList.length > 1) {
      drawerHandlerMethods.setDrawers([emptyScope]);
    }
  };
  ipc.on(ipc.RENDERER_EVENTS_MAP.ON_SELECTED_CHANGE, selectedChange);

  watch(
    () => store.getters.enableViewAllOrgUser,
    val => {
      setDefaultDrawer(defaultParams);
    },
  );
  // 事件卸载
  onUnmounted(() => {
    ipc.off(ipc.RENDERER_EVENTS_MAP.ON_SELECTED_CHANGE, selectedChange);
    ipc.off(ipc.RENDERER_EVENTS_MAP.ON_DATA_LOADED, setTotal);
  });
  return {
    setDefaultDrawer,
  };
};
